var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Tilefloors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M40.004,41.969L8.031,42c-1.099,0.001-1.999-0.897-2-1.996L6,8.031c-0.001-1.099,0.897-1.999,1.996-2 L39.969,6c1.099-0.001,1.999,0.897,2,1.996L42,39.969C42.001,41.068,41.103,41.968,40.004,41.969z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M14,15h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C15,14.552,14.552,15,14,15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M22,15h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C23,14.552,22.552,15,22,15z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M30,15h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C31,14.552,30.552,15,30,15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M38,15h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C39,14.552,38.552,15,38,15z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M14,23h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C15,22.552,14.552,23,14,23z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M22,23h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C23,22.552,22.552,23,22,23z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M30,23h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C31,22.552,30.552,23,30,23z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M38,23h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C39,22.552,38.552,23,38,23z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M14,31h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C15,30.552,14.552,31,14,31z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M22,31h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C23,30.552,22.552,31,22,31z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M30,31h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C31,30.552,30.552,31,30,31z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M38,31h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C39,30.552,38.552,31,38,31z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M14,39h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C15,38.552,14.552,39,14,39z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M22,39h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C23,38.552,22.552,39,22,39z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#35c1f1",
    d: "M30,39h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C31,38.552,30.552,39,30,39z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#0078d4",
    d: "M38,39h-4c-0.552,0-1-0.448-1-1v-4c0-0.552,0.448-1,1-1h4c0.552,0,1,0.448,1,1v4 C39,38.552,38.552,39,38,39z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Tilefloors);
export default __webpack_public_path__ + "static/media/icons8-tilefloors.9824cdf0e3bf7a58cf2c2b285a9cc8f9.svg";
export { ForwardRef as ReactComponent };